/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useEffect } from 'react';

import { canCancelInterval } from '../../../core-modules/base-core-module';
import { useGlobalContext } from '../../providers/GlobalContextProvider';

import type { GridStoreImpl as GridStore } from '../stores';
import type { GridProps } from '../interfaces';

export const useGridUpdates = <RowDataT, TotalRowDataT, FilterT>(
    store: GridStore<RowDataT, TotalRowDataT, FilterT>,
    props: GridProps<RowDataT, TotalRowDataT, FilterT>
) => {
    const { appState } = useGlobalContext() ?? {};

    useEffect(() => {
        if (props.disableAutoUpdate) return;

        store.notificationStore.subscribeToUpdates();

        return () => store.notificationStore.unsubscribeFromUpdates();
    }, []);

    useEffect(() => {
        if (canCancelInterval(appState)) {
            store.notificationStore.unsubscribeFromUpdates();
        }
    }, [appState]);
};